import _ from 'lodash';
import CacheableJson from '../CacheableJson';
import Player from '../../models/Player';
class Players extends CacheableJson {
	get url() {
		return 'nrl/players.json';
	}

	get model() {
		return Player;
	}

	setPositionsName(args) {
		this.each(model => model.setPositionsName(args));

		return this;
	}

	setStatsCostDividedByTotalPoints() {
		this.each(model => model.setStatsCostDividedByTotalPoints());

		return this;
	}

	setFavourite(args) {
		this.each(model => model.setFavourite(args));

		return this;
	}

	setStatsPointsLastRound(args) {
		this.each(model => model.setStatsPointsLastRound(args));

		return this;
	}

	setCoachStats(args) {
		this.each(model => model.setCoachStats(args));

		return this;
	}

	setSquadName(args) {
		this.each(model => model.setSquadName(args));

		return this;
	}

	setOpponents(args) {
		this.each(model => model.setOpponent(args));

		return this;
	}

	get randomPlayer() {
		return this.at(Math.floor(Math.random() * this.size()));
	}

	static filter_by_name(search_value, model) {
		if (!search_value) {
			return true;
		}

		let player_name = model.getFullName().toLowerCase();

		search_value = search_value.toLowerCase();

		return player_name.includes(search_value);
	}

	static filter_by_price(price_str, model) {
		if (!price_str || Number(price_str) === -1) {
			return true;
		}

		const
			[lowest, highest, by_locked] = price_str.split('-').map(Number),
			player_cost = model.get('cost') / 1000,
			is_cost_in_range = lowest <= player_cost && player_cost <= highest;

		if (!_.isUndefined(by_locked)) {
			return is_cost_in_range && !model.get('is_locked');
		}

		return is_cost_in_range;
	}

	static filter_by_squad(squad_id, model) {
		if (!squad_id || Number(squad_id) === -1) {
			return true;
		}

		squad_id = Number(squad_id);

		return squad_id === Number(model.get('squad_id'));
	}

	static filter_by_position(position_id, model) {
		if (!position_id || Number(position_id) === -1) {
			return true;
		}

		const positions = model.get('positions').map(Number);

		position_id = Number(position_id);

		return positions.includes(position_id);
	}

	static filter_dpp_only(is_dpp_only, model) {
		if (!is_dpp_only) {
			return true;
		}

		return _.size(model.get('positions')) > 1;
	}

	static filter_favourite_only(is_favourite_only, model) {
		if (!is_favourite_only) {
			return true;
		}

		return model.get('is_favourite');
	}

	static filter_available_only(is_available_only, model) {
		if (!is_available_only) {
			return true;
		}

		return model.isAvailable();
	}
}

export default Players;